export function StatusBadge({ map, value, testid, label }) {
  const s = map[value] || {
    label: value || "—",
    cls: "bg-fundio-subtle text-fundio-muted border-fundio-border",
  };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}
    >
      {label ?? s.label}
    </span>
  );
}
